<template>
    <simple-layout vertical>
        <basic-card>
            <data-table
                :data="scripts"
                :configuration="scriptTableConfiguration"
                @focusedChanged="focusedChanged"
                @add="onAdd"
                @delete="onDelete"
                component-id="cash-event-scripts-list"
            />
        </basic-card>
        <basic-card v-if="focusedScript != null">
            <form-wrapper>
                <form-text-input :caption="`${$t('name')}`" v-model="focusedScript.name"/>
                <form-text-input :caption="`${$t('description')}`" v-model="focusedScript.description"/>
                <form-select-input v-model="focusedScript.operationDefinitionCode"
                                   :caption="`${$t('operationDefinition.objectName')}`"
                                   :options="operationDefinitionOptions"/>
            </form-wrapper>
            <div style="display: grid; grid-template: 1fr / 2fr 1fr;">
              <blockly-editor
                      v-if="currentOperationDefinition != null"
                      :key="focusedScript.operationDefinitionCode"
                      :toolbox="actualToolbox"
                      :show-script="true"
                      :visual-script="focusedScript.visualScript"
                      @script-changed="onScriptChanged"
              />
              <div>
                <textarea readonly v-model="editorScript.script" style="width: 100%; height: 100%;"/>
<!--              </div><div>-->
<!--                <textarea readonly v-model="editorScript.script" style="width: 100%; height: 100%;"/>-->
              </div>
            </div>
            <simple-button @press="onSave">
                {{ $t('save') }}
            </simple-button>
        </basic-card>
    </simple-layout>
</template>

<script>
    import BasicCard from "../components/layout/BasicCard";
    import MultiCardLayout from "../components/layout/MultiCardLayout";
    import {mapGetters} from "vuex";
    import DataTable from "../components/table/DataTable";
    import BlocklyToolboxes from '../utils/BlocklyToolboxes';
    import FormWrapper from "../components/form/FormWrapper";
    import FormTextInput from "../components/form/FormTextInput";
    import FormSelectInput from "../components/form/FormSelectInput";
    import BlocklyEditor from "../components/scripting/BlocklyEditor";
    import SimpleButton from "../components/button/SimpleButton";
    import SimpleLayout from "../components/layout/SimpleLayout";

    export default {
        name: "CashEventGenerationScripts",
        components: {
            SimpleLayout,
            SimpleButton,
            BlocklyEditor, FormSelectInput, FormTextInput, FormWrapper, DataTable, MultiCardLayout, BasicCard},
        data: function () {
            return {
                actualToolbox: null,
                focusedScript: null,
                editorScript: {
                  script: "",
                  visualScript: ""
                },
                scriptTableConfiguration: {
                    selectionMode: "single",
                    enableAdd: true,
                    allowEdit: true,
                    enableDelete: true,
                    columns: [
                        {
                            caption:  this.$t('name'),
                            datum: d => d.name
                        },
                        {
                            caption:  this.$t('description'),
                            datum: d => d.description != null ?
                                d.description.substr(0, d.description.length < 100 ? d.description.length : 100) :
                                ""
                        },
                        {
                            caption: this.$t('operationDefinition.objectName'),
                            datum: d => d.operationDefinitionCode !== null ?
                                d.operationDefinitionCode
                                : "N/A"
                        }
                    ]
                }
            }
        },
        mounted() {
            this.$store.dispatch("cashEventGenerationScripts/refreshCashEventGenerationScripts");
        },
        watch: {
            focusedScript: {
                handler(newVal) {
                    if(newVal != null) {
                        let possibleDefs =  this.operationDefinitions.filter(def => def.code == newVal.operationDefinitionCode);

                        let relOperationLinkDefinitions = [... this.operationLinkDefinitions
                            .filter(def => def.secondaryOperationDefinitions.includes(possibleDefs[0].id))
                            .map(def => {
                              const id = def.id;
                              const name = def.primarySideName;
                              const primaryDef = this.operationDefinitions.find(opDef => opDef.id == def.primaryOperationDefinitions[0]);
                              return { id, name, operationDefinition: primaryDef }
                            }),
                          ... this.operationLinkDefinitions
                              .filter(def => def.primaryOperationDefinitions.includes(possibleDefs[0].id))
                              .map(def => {
                                const id = def.id;
                                const name = def.secondarySideName;
                                const secondaryDef = this.operationDefinitions.find(opDef => opDef.id == def.secondaryOperationDefinitions[0]);
                                return { id, name, operationDefinition: secondaryDef }
                              }),
                          {
                            id: possibleDefs[0].id,
                            name: possibleDefs[0].name,
                            operationDefinition: possibleDefs[0]
                          }
                        ];
                        // linkedOperationDefinitions = [...new Set(linkedOperationDefinitions)];
                        // let linkedDefinitions =  this.operationDefinitions.filter(def => linkedOperationDefinitions.includes(def.id));
                        // linkedDefinitions.primaryOperationDefinition = this.operationDefinitions.filter(def => linkedOperationDefinitions.includes(def.id))


                        this.actualToolbox = BlocklyToolboxes.cashEvent(possibleDefs[0], relOperationLinkDefinitions, this.operationDefinitions);
                    }
                },
                deep: true
            }
        },
        computed: {
            ... mapGetters({
                scripts: "cashEventGenerationScripts/cashEventGenerationScripts",
                operationDefinition: "operationDefinitions/operationDefinition",
                operationDefinitions: "operationDefinitions/operationDefinitions",
                operationLinkDefinitions: "operationLinkDefinitions/operationLinkDefinitions"
            }),
            operationDefinitionOptions() {
                return this.operationDefinitions.map(def => ({id: def.code, name: def.name}));
            },
            currentOperationDefinition() {
                if(this.focusedScript == null) return null;
                let possibleDefs =  this.operationDefinitions.filter(def => def.code == this.focusedScript.operationDefinitionCode);
                return possibleDefs.length == 1 ? possibleDefs[0] : null;
            }
        },
        methods: {
            focusedChanged(focused) {
                this.focusedScript = focused;
            },
            onScriptChanged({script, visualScript}) {
                this.editorScript.script = script;
                this.editorScript.visualScript = visualScript;
            },
            onSave() {
                let toSave = {
                    ... this.focusedScript,
                    visualScript: this.editorScript.visualScript,
                    script: this.editorScript.script
                }
                this.$store.dispatch("cashEventGenerationScripts/saveCashEventGenerationScript", toSave)
                    .then(() => this.$store.dispatch("cashEventGenerationScripts/refreshCashEventGenerationScripts"));
            },
            onAdd() {
                this.focusedScript = {};
            },
            onDelete() {

            }
        }
    }
</script>

<style lang="scss" scoped>

</style>
